export const hm5LimitedReleasesListConstants = {
  HM5_LIMITED_RELEASES_LIST_LOADING: "HM5_LIMITED_RELEASES_LIST_LOADING",
  HM5_LIMITED_RELEASES_LIST_SUCCESS: "HM5_LIMITED_RELEASES_LIST_SUCCESS",
  HM5_LIMITED_RELEASES_LIST_FAILURE: "HM5_LIMITED_RELEASES_LIST_FAILURE",
};
